"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var __jsx = _react.default.createElement;
var Authors = function Authors(props) {
  var authors = props.authors;
  var maxAuthors = 10;
  if (!authors || !authors.length) return null;
  return __jsx("span", null, authors.slice(0, maxAuthors).map(function (a, index) {
    return __jsx("span", {
      key: "".concat(a.lastName).concat(a.firstName).concat(a.middleInitial)
    }, a.lastName && __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: " ".concat(a.lastName)
      }
    }), a.firstName && __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: " ".concat(a.firstName)
      }
    }), a.middleInitial && __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: "".concat(a.middleInitial)
      }
    }), index + 1 === authors.length ? '.' : ',');
  }), authors.length > maxAuthors && ' et al.');
};
var _default = Authors;
exports.default = _default;